import type { AppDispatch } from "@/store";

const getGroupClassesOptions = (patientId?: string) => {
  return {
    params: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "is-active": true,
      // TODO: future paging implementation?
      "page-size": 200,
      ...(patientId && { "patient-external-id": patientId }),
    },
    url: "/schedule/family/group-classes",
  };
};

const onQueryStartedForGroupClassMutation = ({
  getGroupClassEndpoint,
  scheduleApi,
}: {
  getGroupClassEndpoint: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  scheduleApi: any;
}) => {
  return async (
    arg: { groupClassExternalId: string; patientExternalId: string },
    {
      dispatch,
      queryFulfilled,
    }: {
      dispatch: AppDispatch;
      queryFulfilled: Promise<{ data: { data?: string; status?: string } }>;
    },
    // eslint-disable-next-line max-params
  ) => {
    // Pessimistic Update - Wait for the query to be fulfilled before updating the cache
    // See: https://redux-toolkit.js.org/rtk-query/usage/manual-cache-updates#pessimistic-updates
    await queryFulfilled;
    const { groupClassExternalId, patientExternalId: patientId } = arg;

    // retrieve the updated group class object from the API
    // getGroupClassEndpoint's onQueryStarted will update the getGroupClasses cache accordingly
    dispatch(
      scheduleApi.endpoints[getGroupClassEndpoint].initiate(
        { groupClassExternalId, patientId },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        { forceRefetch: true },
      ),
    );
  };
};

export { getGroupClassesOptions, onQueryStartedForGroupClassMutation };
